export default __webpack_public_path__ + "static/media/section-bg-licensing.812a3c42.jpg";